export default {
      id: "twitter-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#twitter",
      toString: function () {
        return this.url;
      }
    }